import { UseFormRegisterReturn } from "react-hook-form";

import { Form } from "react-bootstrap";

interface FloatingSwitchProps {
  type?: string;
  name: string;
  label: string;
  register: UseFormRegisterReturn;
  helpText?: string;
  className?: string;
}

export default function FloatingSwitch({ name, label, register, helpText }: FloatingSwitchProps) {
  return (
    <div className="mb-4">
      <Form.Check type="switch" label={label} id={name} {...register} />
      <div id={`${name}-help`} className="form-text" style={{ marginLeft: "2.5rem" }}>
        {helpText}
      </div>
    </div>
  );
}
